import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-wool',
    templateUrl: './wool.component.html',
    styleUrls: ['./wool.component.scss'],
    standalone: false
})
export class WoolComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
